// extracted by mini-css-extract-plugin
export default {"messages":"Messages_messages__-3vWI","enter-message":"Messages_enter-message__n0U1M"};